import dayjs from 'dayjs';
import { reminderLabelToValueMap } from '~/components/Tasks/tasks.utils';
import {
    ICreateTaskRequest,
    IFetchTasksRequest,
    TaskFilters,
    TaskSchema
} from '~/components/Tasks/types/tasks.types';
import { TasksAdapter } from '~/services/adapters/tasks.adapter';

export const DEFAULT_TASKS_PER_PAGE_NUMBER = 30;

export class TasksService extends TasksAdapter {
    async fetchUserTasks(params: IFetchTasksRequest = {}) {
        const DEFAULT_VALUES = {
            filter_by: TaskFilters.ALL,
            page: 1,
            perPage: DEFAULT_TASKS_PER_PAGE_NUMBER,
            sort_by: 'due_date',
            sort_desc: false,
            tasks_misc_offset: 0,
            wf_approvals_misc_offset: 0,
            wf_approvals_after_step_execution_offset: 0
        } as const;

        const data = {
            ...DEFAULT_VALUES,
            ...params,
            curr_date: dayjs(new Date()).format('MM/DD/YYYY')
        };

        return this._fetchUserTasks(data);
    }

    async fetchWorkspaceTasks(
        workspaceId: string,
        params: IFetchTasksRequest = {}
    ) {
        const DEFAULT_VALUES = {
            page: 1,
            perPage: DEFAULT_TASKS_PER_PAGE_NUMBER,
            sort_by: 'due_date',
            sort_desc: false
        } as const;

        const data = {
            ...DEFAULT_VALUES,
            ...params,
            curr_date: dayjs(new Date()).format('MM/DD/YYYY')
        };
        return super.fetchWorkspaceTasks(workspaceId, data);
    }

    async fetchTasks(workspaceId?: string, params: IFetchTasksRequest = {}) {
        if (workspaceId) {
            const workspaceTasks = await this.fetchWorkspaceTasks(
                workspaceId,
                params
            );
            return { tasks: workspaceTasks, offsets: {} };
        } else {
            return this.fetchUserTasks(params);
        }
    }

    async fetchUserTaskCount() {
        const data = {
            curr_date: dayjs(new Date()).format('MM/DD/YYYY')
        };

        return super._fetchUserTaskCount(data);
    }

    async fetchWorkspaceTaskCount(workspaceId: string) {
        const data = {
            curr_date: dayjs(new Date()).format('MM/DD/YYYY')
        };

        return super._fetchWorkspaceTaskCount(workspaceId, data);
    }

    async fetchTaskCount(workspaceId?: string) {
        if (workspaceId) {
            return this.fetchWorkspaceTaskCount(workspaceId);
        } else {
            return this.fetchUserTaskCount();
        }
    }

    convertTaskDataForServer(task: TaskSchema): ICreateTaskRequest {
        const dueDate = task.due_date
            ? dayjs(task.due_date).format('YYYY-MM-DD')
            : null;
        const reminder = task.reminder
            ? reminderLabelToValueMap[task.reminder]
            : null;
        const status = task.isCompleted ? 'completed' : 'pending';
        return { ...task, due_date: dueDate, reminder, status };
    }
}
